import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  UserConnectedLeadersListLoadMoreFulfilledAction,
  UserFollowedLeadersListLoadFulfilledAction,
  UserFollowedLeadersListLoadMoreFulfilledAction,
  UserNetworkLeadersListLoadMoreFulfilledAction,
} from '../../domains/leadersManagement/actions.types';
import { UserNetworkLeadersListLoadAction } from '../../domains/leadersManagement/loadAllLeadersActions.types';
import { UserConnectedLeadersListLoadAction } from '../../domains/leadersManagement/loadConnectedLeadersActions.types';
import {
  UserCoverImageDeleteFulfilledAction,
  UserCoverImageUploadFulfilledAction,
} from '../../domains/userCoverImages/actions.types';
import { UserHeaderLoadAction } from '../../domains/userHeaderLoad/actions.types';

import { UserCoverImages } from './types';

export type UserCoverImageAction =
  | UserHeaderLoadAction
  | UserConnectedLeadersListLoadAction
  | UserCoverImageDeleteFulfilledAction
  | UserCoverImageUploadFulfilledAction
  | UserNetworkLeadersListLoadAction
  | UserNetworkLeadersListLoadMoreFulfilledAction
  | UserConnectedLeadersListLoadMoreFulfilledAction
  | UserFollowedLeadersListLoadFulfilledAction
  | UserFollowedLeadersListLoadMoreFulfilledAction;

const initialState: UserCoverImages = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<UserCoverImages, UserCoverImageAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_COVER_IMAGE.UPLOAD_FULFILLED':
      return update(state, action.payload.userId, {
        backgroundUrl: action.payload.coverImageUrlTemplate,
        hasDefaultCoverImage: false,
      });
    case 'USER_COVER_IMAGE.DELETE_FULFILLED':
      return update(state, action.payload.userId, {
        backgroundUrl: action.payload.coverImageUrlTemplate,
        hasDefaultCoverImage: true,
      });
    case 'USER_HEADER.LOAD_PENDING':
      return moveToPending(state, [action.payload.id]);
    case 'USER_HEADER.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'USER_HEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userCoverImages);
    case 'CONNECTED_LEADERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userCoverImages);
    case 'FOLLOWED_LEADERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userCoverImages);
    case 'FOLLOWED_LEADERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userCoverImages);
    case 'CONNECTED_LEADERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userCoverImages);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userCoverImages);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userCoverImages);
    default:
      return state;
  }
};

export default reducer;
